import type { IAdViewLink, IAdViewUsedCarOfTheYear } from "@finn-no/adview-provider-frontend-types";
import { useLingui } from "@lingui/react";
import { ElementType, Intent } from "@mobility-item-page/utilities/client";
import usePulse from "../../utils/pulse-tracking/usePulse.ts";
import { CarOfTheYear } from "./CarOfTheYear.tsx";
import { ExpandableSection } from "./expandable-section/ExpandableSection.tsx";
import LoanWarning from "./LoanWarning.js";

type Props = {
  description?: string;
  loanWarningLink?: IAdViewLink;
  carOfTheYear?: IAdViewUsedCarOfTheYear;
};

const Description = ({ description, loanWarningLink, carOfTheYear }: Props) => {
  const { i18n } = useLingui();
  const { trackClick } = usePulse();

  const trackingEvent = () => {
    // Tracking event: CE_ev38
    trackClick({
      name: "View full ad",
      objectId: "CE_ev38",
      elementType: ElementType.Button,
      intent: Intent.View,
    });
  };

  return (
    <>
      {carOfTheYear && <CarOfTheYear carOfTheYear={carOfTheYear} />}
      {description && description?.length !== 0 && (
        <ExpandableSection
          headerText={i18n.t("itemPageLayout.description.title", { message: "Description" })}
          bodyText={description}
          className={`pt-40 ${carOfTheYear ? "" : "border-t mt-40"}`}
          trackingEvent={trackingEvent}
          readMoreText={i18n.t("itemPageLayout.description.readmore", {
            message: "Show full description",
            comment: "Button text to show full description of expandable section",
          })}
        />
      )}
      {loanWarningLink && <LoanWarning loanWarningLink={loanWarningLink} />}
    </>
  );
};

export default Description;
